/* BCMK: click-to-play YouTube. Shows a cover photo until someone presses play, so pages stay fast.
   Any <button data-yt="VIDEO_ID" data-yt-title="..."> on the page is swapped for the video when clicked. */
(function () {
  if (window.bcmkVideo) return;
  window.bcmkVideo = true;
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-yt]');
    if (!b) return;
    var f = document.createElement('iframe');
    f.src = 'https://www.youtube-nocookie.com/embed/' + b.getAttribute('data-yt') + '?autoplay=1&rel=0';
    f.title = b.getAttribute('data-yt-title') || 'Video';
    f.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    f.allowFullscreen = true;
    b.replaceWith(f);
  });
})();
